import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { getAvatar } from '../../utils';
import {
    PostCardProps,
    CardHeaderProps,
    DashboardCardBodyProps,
    CardLikeAndCommentProps,
    ActionProps,
    CardCommentInputProps,
    CardCommentContentProps,
    CommentsProps,
    CardSubCommentContentProps,
    CommentProps,
} from './PostComponents.types';

import { IconButton } from '../IconButton';
import { Input } from '../Input';
import { FiCalendar, FiEdit3 } from 'react-icons/fi';
import { MdOutlineMoreHoriz } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';

import moment from 'moment';
import doctorSalim from '../../Assets/doctorSalim.png';
import like from '../../Assets//like.svg';
import emptyLike from '../../Assets//emptyLike.svg';
import conversation from '../../Assets//conversation.svg';
import emptyConversation from '../../Assets//emptyConversation.svg';

import repondre from '../../Assets//repondre.svg';
import conversationactive from '../../Assets//conversationactive.svg';
import commentLike from '../../Assets//commentLike.svg';
import likeActive from '../../Assets//likeActive.svg';
import './style.scss';
import { CommentsTypes, formDataSubCommentTypes } from '../../types';
import { useSubComments } from './../../hooks';
import { useFormik } from 'formik';

export const PostCard: FC<PostCardProps> = ({ children, className }) => {
    const classes = classNames('sobrusPost', className);
    return (
        <div className={classes}>
            <div className='sobrusPost__cardcontent'>{children}</div>
        </div>
    );
};

export const CardHeader: FC<CardHeaderProps> = ({
    date,
    className,
    image = <img src={doctorSalim} alt='' />,
    name = 'Dr. Salim',
}) => {
    const classes = classNames('sobrusPost__header', className);
    return (
        <div className={classes}>
            <div className='sobrusPost__header__imageContainer'>
                <div className='sobrusPost__header__image'>{image}</div>
                <div>
                    <p className='sobrusPost__header__name'>{name}</p>
                    <div className='sobrusPost__header__dateContainer'>
                        <IconButton
                            style={{
                                margin: 0,
                                lineHeight: 1,
                                padding: '0.4rem',
                                borderRadius: '0.5rem',
                                height: 'initial',
                                width: 'initial',
                            }}
                            color='warning'
                        >
                            <FiCalendar size={10} />
                        </IconButton>
                        <p className='sobrusPost__header__date'>{moment(date).format('YYYY-MM-DD HH:mm:ss')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const DashboardCardBody: FC<DashboardCardBodyProps> = ({
    imageLink,
    video,
    source,
    title,
    customImageComponent,
    className,
    description,
    openInNewTab,
    imgResizeMode = 'cover',
}) => {
    const classes = classNames('sobrusPost__body', className);

    const renderImage = () => {
        if (customImageComponent) {
            return customImageComponent;
        } else {
            return !video ? (
                <img
                    style={{
                        objectFit: imgResizeMode,
                        cursor: imageLink ? 'pointer' : 'auto',
                    }}
                    onClick={() => imageLink && openInNewTab && openInNewTab(imageLink)}
                    src={source}
                    alt=''
                />
            ) : (
                <iframe
                    title={video}
                    allowFullScreen
                    // frameBorder='0'
                    src={`https://www.youtube.com/embed/${video.split('v=')[1]}`}
                    style={{ height: 400, width: '100%', borderRadius: 10 }}
                />
            );
        }
    };
    return (
        <>
            <div className={classes}>
                {title && <h2 className='sobrusPost__body__title'>{title}</h2>}
                <div className='sobrusPost__body__image'>{renderImage()}</div>
            </div>

            {description && (
                <p
                    dangerouslySetInnerHTML={{
                        __html: description?.replace(/\n/g, '<br />'),
                    }}
                    className='sobrusPost__body__text'
                />
            )}
        </>
    );
};
export const CardLikeAndComment: FC<CardLikeAndCommentProps> = ({
    commentCount,
    isLiked,
    reactionCount,
    onClickLike,
    setOpen,
    hideCommentsTag,
    className,
}) => {
    const classes = classNames('sobrusPost__likeAndComments', className);
    return (
        <div className={classes}>
            <div className='sobrusPost__likeAndComments__container'>
                <IconButton onClick={onClickLike} className='sobrusPost__likeAndComments__containerIcon' color='danger'>
                    {isLiked ? <img className='active' src={like} alt='' /> : <img src={emptyLike} alt='' />}
                </IconButton>
                <p>{reactionCount ?? 0}</p>
            </div>
            {!hideCommentsTag && (
                <div className='sobrusPost__likeAndComments__container'>
                    <IconButton
                        className='sobrusPost__likeAndComments__containerIcon'
                        color='primary'
                        onClick={() => setOpen && setOpen((prev: boolean) => !prev)}
                    >
                        {commentCount && +commentCount > 0 ? (
                            <img className='active' src={conversation} alt='' />
                        ) : (
                            <img src={emptyConversation} alt='' />
                        )}
                    </IconButton>
                    <p>{commentCount ? commentCount : 0}</p>
                </div>
            )}
        </div>
    );
};

export const CardCommentContent: FC<CardCommentContentProps> = ({ children, open }) => {
    return <>{open && <div className='sobrusPost__comments'>{children}</div>}</>;
};

export const Comments: FC<CommentsProps> = ({
    comments,
    editId,
    user,
    handleSubmit,
    editvalue,
    handleChange,
    actionsLoading,
    deleteComment,
    editComment,
    loading,
    handelLikeComment,
    postId,
    url,
}) => {
    return (
        <>
            {!loading &&
                comments &&
                comments?.map((comment, key) =>
                    editId === comment?.id ? (
                        <div key={comment.id} style={{ marginBottom: 12 }}>
                            <CardCommentInput edit {...{ user, handleSubmit, editvalue, handleChange, index: key }} />
                        </div>
                    ) : (
                        <Comment
                            key={comment.id}
                            {...{
                                user,
                                comment,
                                actionsLoading,
                                deleteComment,
                                editComment,
                                handelLikeComment,
                                index: key,
                                postId,
                                url,
                            }}
                        />
                    ),
                )}
        </>
    );
};
export const Comment: FC<CommentProps> = ({
    user,
    comment,
    actionsLoading,
    deleteComment,
    editComment,
    handelLikeComment,
    index,
    postId,
    url,
}) => {
    const [currentComment, setCurrentComment] = useState<CommentsTypes>(comment);
    const [replie, setRiplie] = useState(false);
    return (
        <div className='sobrusPost__comments__content'>
            <div className='sobrusPost__comments__content__containe'>
                <div className='sobrusPost__comments__image'>
                    <div
                        className={`sobrusPost__comments__avatar ${
                            getAvatar(user?.fullName)?.length > 2 ? 'sobrusPost__comments__avatar-sm' : ''
                        }`}
                    >
                        <span>{getAvatar(currentComment?.createdBy?.fullName)}</span>
                    </div>
                </div>
                <div className='sobrusPost__comments__container'>
                    <div className='sobrusPost__comments__headerContainer'>
                        <div className='sobrusPost__comments__test'>
                            <div className='sobrusPost__comments__name'>
                                {currentComment?.createdBy?.fullName} &bull;{' '}
                                <span className='sobrusPost__comments__time'>
                                    {' '}
                                    {moment(currentComment?.createdAt).fromNow().split('il y a')[1] ||
                                        moment(currentComment?.createdAt).fromNow().split('ago')[0]}{' '}
                                </span>
                            </div>
                            {deleteComment && editComment && (
                                <Actions
                                    {...{
                                        comment: currentComment,
                                        index,
                                        user,
                                        actionsLoading,
                                        deleteComment,
                                        editComment,
                                    }}
                                />
                            )}
                        </div>
                        <div className='sobrusPost__comments__text'>{currentComment?.content}</div>
                    </div>
                    <div className='sobrusPost__comments__likeAndReplies'>
                        <div
                            onClick={() => handelLikeComment && handelLikeComment(currentComment, setCurrentComment)}
                            className='sobrusPost__comments__like'
                        >
                            {currentComment.isLiked ? (
                                <img className='active' src={likeActive} alt='' />
                            ) : (
                                <img src={commentLike} alt='' />
                            )}

                            <span
                                style={{
                                    color: currentComment.isLiked ? '#DF633A' : '#000',
                                }}
                            >
                                J’aime
                            </span>
                            {+currentComment.reactionCount > 0 && (
                                <span style={{ fontSize: 14, marginLeft: 6 }}>
                                    &bull; {+currentComment.reactionCount}
                                </span>
                            )}
                        </div>
                        <div
                            onClick={() => {
                                setRiplie(!replie);
                            }}
                            className='sobrusPost__comments__comment'
                        >
                            {+currentComment?.commentCount > 0 ? (
                                <img className='active' src={conversationactive} alt='' />
                            ) : (
                                <img src={repondre} alt='' />
                            )}
                            <span
                                style={{
                                    color: +currentComment?.commentCount > 0 ? '#55ACED' : '#000',
                                }}
                            >
                                {' '}
                                Répondre{' '}
                            </span>
                            {+currentComment?.commentCount > 0 && (
                                <span style={{ fontSize: 14, marginLeft: 6 }}>
                                    &bull; {currentComment?.commentCount}
                                </span>
                            )}
                        </div>
                    </div>
                    <CardSubCommentContent
                        {...{
                            comment,
                            user,
                            replie,
                            postId,
                            url,
                            setCurrentComment,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

const CardSubCommentContent: FC<CardSubCommentContentProps> = ({
    url,
    comment,
    user,
    replie,
    postId,
    setCurrentComment,
}) => {
    // / subComments
    // const [open, setOpen] = useState(false);
    const [initialValues] = useState<formDataSubCommentTypes>({
        postId,
        repliedToCommentId: comment?.id.toString(),
        content: '',
        editContent: '',
    });
    const { handleChange, values, handleSubmit, setFieldValue } = useFormik({
        enableReinitialize: true,
        initialValues,
        onSubmit: (values: formDataSubCommentTypes) => {
            !editId && values?.content !== '' && postSubComment(`${url}/api/comments`, values);
            editId &&
                user &&
                values?.editContent !== '' &&
                values?.editContent !== undefined &&
                updateSubComment(`${url}/api/comments/${editId}`, {
                    content: values?.editContent,
                    userId: user?.id,
                });
        },
    });

    const {
        editId,
        subComments,
        subCommentLoading,
        updateSubComment,
        postSubComment,
        editComment,
        actionsLoading,
        deleteComment,
        // handleLikeSubComment,
    } = useSubComments({
        url: `${url}/api/comments/${comment?.id}/replies`,
        likeCommentUrl: { p1: `${url}/api/comments`, p2: 'interactions' },
        deleteCommentUrl: `${url}/api/comments`,
        user,
        open: replie,
        setFieldValue,
        setCurrentComment,
    });
    return (
        <>
            {replie && (
                <>
                    <div style={{ margin: '14px 0' }}>
                        <CardCommentInput
                            {...{
                                user,
                                handleSubmit,
                                subCommentLoading,
                                value: values?.content,
                                handleChange,
                            }}
                        />
                    </div>

                    {subComments &&
                        subComments?.map((repli, key) => (
                            <>
                                {editId === repli?.id ? (
                                    <div style={{ marginBottom: 12 }}>
                                        <CardCommentInput
                                            edit
                                            {...{
                                                user,
                                                handleSubmit,
                                                editvalue: values?.editContent,
                                                handleChange,
                                                index: key,
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div key={repli.id} className='sobrusPost__comments__content'>
                                        <div className='sobrusPost__comments__content__containe'>
                                            <div className='sobrusPost__comments__image'>
                                                <div className='sobrusPost__comments__avatar'>
                                                    <span>{getAvatar(repli?.createdBy?.fullName)}</span>
                                                </div>
                                            </div>
                                            <div className='sobrusPost__comments__container'>
                                                <div className='sobrusPost__comments__headerContainer'>
                                                    <div className='sobrusPost__comments__test'>
                                                        <div className='sobrusPost__comments__name'>
                                                            {repli?.createdBy?.fullName} &bull;{' '}
                                                            <span className='sobrusPost__comments__time'>
                                                                {' '}
                                                                {moment(repli?.createdAt)
                                                                    .fromNow()
                                                                    .split('il y a')[1] ||
                                                                    moment(repli?.createdAt)
                                                                        .fromNow()
                                                                        .split('ago')[0]}{' '}
                                                            </span>
                                                        </div>
                                                        <Actions
                                                            {...{
                                                                comment: repli,
                                                                index: key,
                                                                user,
                                                                id: comment?.id,
                                                                actionsLoading,
                                                                deleteComment,
                                                                editComment,
                                                            }}
                                                        />
                                                    </div>
                                                    <div className='sobrusPost__comments__text'>{repli?.content}</div>
                                                </div>
                                                {/* <div className='sobrusPost__comments__likeAndReplies'>
                                                    <div
                                                        onClick={() => handleLikeSubComment(key, repli)}
                                                        className='sobrusPost__comments__like'
                                                    >
                                                        {repli?.isLiked ? (
                                                            <img className='active' src={likeActive} alt='' />
                                                        ) : (
                                                            <img src={commentLike} alt='' />
                                                        )}

                                                        <span
                                                            style={{
                                                                color: repli?.isLiked ? '#DF633A' : '#000',
                                                            }}
                                                        >
                                                            J’aime
                                                        </span>
                                                        {+repli?.reactionCount > 0 && (
                                                            <span style={{ fontSize: 14, marginLeft: 6 }}>
                                                                &bull; {repli?.reactionCount}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        ))}
                </>
            )}
        </>
    );
};

export const CardCommentInput: FC<CardCommentInputProps> = ({
    edit,
    user,
    handleSubmit,
    editvalue,
    value,
    handleChange,
}) => {
    return (
        <div className='sobrusPost__comments__input' style={{ marginBottom: 20 }}>
            <div className='sobrusPost__comments__image'>
                {user?.image ? (
                    <img src={user?.image} alt='' />
                ) : (
                    <div
                        className={`sobrusPost__comments__avatar ${
                            getAvatar(user?.fullName)?.length > 2 ? 'sobrusPost__comments__avatar-sm' : ''
                        }`}
                    >
                        <span>{getAvatar(user?.fullName)}</span>
                    </div>
                )}
            </div>
            <form
                style={{ width: '100%', position: 'relative' }}
                onSubmit={(e) => {
                    e?.preventDefault();
                    handleSubmit && handleSubmit(e);
                }}
            >
                {/* <div className='sobrusPost__comments__loader'> */}
                <Input
                    placeholder={'Insérer votre commentaire ici …'}
                    value={edit ? editvalue : value}
                    name={edit ? 'editContent' : 'content'}
                    onChange={(e) => handleChange && handleChange(e)}
                    style={{ position: 'relative' }}
                />
                {/* {loading && <InpuLoader />} */}
                {/* </div> */}
            </form>
        </div>
    );
};

const Actions: FC<ActionProps> = ({ comment, index, user, deleteComment, editComment }) => {
    const [actions, setActions] = useState(false);

    return (
        <>
            {comment && comment?.createdBy?.fullName === user?.fullName ? (
                <div className='sobrusPost__comments__actionsIcon' onClick={() => setActions(!actions)}>
                    <MdOutlineMoreHoriz size={24} />
                    {actions && (
                        <div
                            onMouseLeave={() => {
                                setActions(false);
                            }}
                            className='sobrusPost__comments__actions'
                        >
                            <div
                                onClick={() =>
                                    // data && sub
                                    //     ? deleteSubComment(comment?.id, id)
                                    {
                                        deleteComment && deleteComment(comment?.id);
                                    }
                                }
                                className='sobrusPost__comments__action sobrusPost__comments__action--delete'
                            >
                                <RiDeleteBin6Line size={18} /> <span>Supprimer</span>
                            </div>
                            <div
                                onClick={() => editComment && editComment(comment, index)}
                                className='sobrusPost__comments__action sobrusPost__comments__action--edit'
                            >
                                <FiEdit3 size={18} /> <span>Modifier</span>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                ''
            )}
        </>
    );
};
